import React, { type AllHTMLAttributes, type ComponentType, type ReactNode } from 'react';
import { styled } from '@compiled/react';
import Tooltip from '@atlaskit/tooltip';
import type { IssueId } from '@atlassian/jira-software-deployments-common-table/src/model/issue';
import { useIssue } from '../../../services/core-data/main';

type Props = {
	id: IssueId;
	children: ReactNode;
};
/**
 * There is an inconsistency between @atlaskit/tooltip::Tooltip::tag type and
 * the @compiled/react div type. This inconsistency is on the ref type that
 * compiled sets vs @atlaskit's type and caused only because @compiled/react
 * supports `string` legacy refs for class based usage.
 *
 * This cast is safe, since that's the only difference.
 */
type TooltipTagType = ComponentType<
	AllHTMLAttributes<HTMLDivElement> & {
		ref: React.Ref<HTMLElement>;
	}
>;

const ListItemContentTooltip = ({ id, children }: Props) => {
	const issue = useIssue(id);
	if (!issue) {
		throw new Error('issue not found but is required for ListItemContentTooltip');
	}
	return (
		<Tooltip
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			tag={CustomTooltipTag as TooltipTagType}
			content={`${issue.key}: ${issue.summary}`}
			position="top"
		>
			{children}
		</Tooltip>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const CustomTooltipTag = styled.div({
	width: '100%',
	height: '100%',
});

export default ListItemContentTooltip;
